import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { DatePipe } from '@angular/common';
import { TimetableService } from '../../services/timetable.service';
import { DatewiseEvents } from '../../../calendar/models/datewise-events';
import { SwiperNavigationInterface, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { DateUtils } from '../../../../../utils/date-utils';

@Component({
  selector: 'app-mobile-weekly-timetable',
  templateUrl: './mobile-weekly-timetable.component.html',
  styleUrls: ['./mobile-weekly-timetable.component.scss']
})
export class MobileWeeklyTimetableComponent extends ComponentBase implements OnInit {

  constructor(private pageHeadingService: PageHeadingService
    , private datepipe: DatePipe
    , private timetableService: TimetableService) {
    super();
  }

  startDate: Date = new Date();
  EndDate: Date = new Date();
  selectedWeek: Array<DatewiseEvents>;
  currentmonth: string;
  weeks: Array<Array<DatewiseEvents>> = [];
  dataFetched: boolean;
  private navigation: SwiperNavigationInterface = {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
  config: SwiperConfigInterface = {
    navigation: this.navigation
  };

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Timetable"));
    this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay() != 0 ? this.startDate.getDay() - 1 : 6));
    this.EndDate.setMonth(this.startDate.getMonth());
    this.EndDate.setDate(this.startDate.getDate() + 13);
    let month_view_start_date = new Date(this.startDate);
    let month_view_end_date = new Date(this.EndDate);;
    let days: Array<DatewiseEvents> = [];
    while (month_view_start_date < month_view_end_date || month_view_start_date.getTime() == month_view_end_date.getTime()) {
      let day = new DatewiseEvents();
      day.event_date = DateUtils.DateToISOString(month_view_start_date);
      day.time_table = [];
      days.push(day);
      month_view_start_date.setDate(month_view_start_date.getDate() + 1);
    }
    while (days.length > 0) {
      this.weeks.push(days.splice(0, 7));
    }

    let sub = this.timetableService.getTimetableByDateRange(this.startDate, this.EndDate)
      .subscribe(days => {
        this.weeks.forEach((week, i) => {
          week.forEach((day, j) => {
            let d = days.find(o => o.event_date.split('T')[0] == day.event_date.split('T')[0]);
            if (d) {
              this.weeks[i][j] = d;
            }
          });
        });
        this.onSwipe(0);
        this.dataFetched = true;
      });
    this.addSubscription(sub);
  }

  setCurrentMonth() {
    let weekStartMonth = this.datepipe.transform(this.selectedWeek[0].event_date, "MMMM y");
    let weekEndMonth = this.datepipe.transform(this.selectedWeek[this.selectedWeek.length - 1].event_date, "MMMM y");
    if (weekStartMonth == weekEndMonth) {
      this.currentmonth = weekStartMonth;
    }
    else {
      let year1 = this.datepipe.transform(this.selectedWeek[0].event_date, "y");
      let year2 = this.datepipe.transform(this.selectedWeek[this.selectedWeek.length - 1].event_date, "y")
      if (year1 != year2) {
        this.currentmonth = this.datepipe.transform(this.selectedWeek[0].event_date, "MMM y")
          + " - "
          + this.datepipe.transform(this.selectedWeek[this.selectedWeek.length - 1].event_date, "MMM y");
      }
      else {
        this.currentmonth = this.datepipe.transform(this.selectedWeek[0].event_date, "MMM")
          + " - "
          + this.datepipe.transform(this.selectedWeek[this.selectedWeek.length - 1].event_date, "MMM y");;
      }
    }
  }

  onSwipe(index: number) {
    this.selectedWeek = this.weeks[index];
    this.setCurrentMonth();
  }

}
